module.exports = __webpack_public_path__ + "static/media/remote.bed2a437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/remote.png
// module id = 1084
// module chunks = 110